import { useEffect, useState } from 'react';
import { getOfficialRate } from './currencyService';

export function useExchangeRate() {
  const [rate, setRate] = useState(null);
  
  useEffect(() => {
    let active = true;
    getOfficialRate().then((r) => {
      if (active) setRate(r);
    }).catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  
  return rate;
}